'use client'

import { useTranslations } from '@/lib/next-shim'

import { Container, Stack } from '@mui/material'

import { getLandingVariant } from '@/utils/landing-variant'
import { PageTitle } from '@/shared/ui/seo/PageTitle'

import { ProfileMainCard } from './ProfileMainCard'
import { InsIdentitySection } from './InsIdentitySection'
import { SecuritySection } from './SecuritySection'
import { PrimaryCareSection } from './PrimaryCareSection'
import { EmergencyContactSection } from './EmergencyContactSection'
import { SavedAddressesSection } from './SavedAddressesSection'
import { InsuranceSection } from './InsuranceSection'

export function ProfilePage() {
  const t = useTranslations()

  const variant = getLandingVariant()
  const showInsurance = variant === 'zoomdocny'

  return (
    <Container maxWidth="md" sx={{ py: 5 }} data-testid="profile-page">
      <PageTitle title={t('page.AccountSettings.profile.title')} />

      <Stack spacing={5}>
        <ProfileMainCard />
        <InsIdentitySection />
        <SecuritySection />
        <PrimaryCareSection />
        <EmergencyContactSection />
        <SavedAddressesSection />
        {showInsurance && <InsuranceSection />}
      </Stack>
    </Container>
  )
}
